import { routerMiddleware } from "connected-react-router";
import {
  applyMiddleware,
  compose,
  createStore as createReduxStore
} from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import { history } from "../main";
import makeRootReducer from "./reducers";

const createStore = (initialState = {}) => {
  const router = routerMiddleware(history);
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk, router];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];

  if (process.env.NODE_ENV !== "production") {
    const logger = createLogger({
      collapsed: (getState, action, logEntry) => !logEntry.error,
      duration: true,
      diff: true,
    });
    middleware.push(logger);
  }

  let composeEnhancers = compose;

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function") {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  const addPromiseSupportToDispatch = (store) => {
    const rawDisptach = store.dispatch;
    return (action) => {
      if (typeof action.then === "function") {
        return action.then(rawDisptach);
      }
      return rawDisptach(action);
    };
  };

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  );
  store.asyncReducers = {};

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const reducers = require("./reducers").default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  store.dispatch = addPromiseSupportToDispatch(store);

  return store;
};

export default createStore;



// WEBPACK FOOTER //
// ./src/store/createStore.js